"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixAssetWidget = void 0;
const react_1 = __importStar(require("react"));
const resource_browser_1 = require("@squiz/resource-browser");
const parseMatrixAssetUri = (uri) => {
    if (typeof uri !== 'string' || uri.substring(0, 15) !== 'matrix-asset://') {
        return null;
    }
    const [source, ...resourceParts] = uri.substring(15).split('/');
    const resource = resourceParts.join('/');
    if (!source.length || !resource.length) {
        return null;
    }
    return {
        sourceId: source,
        resourceId: resource,
    };
};
const MatrixAssetWidget = ({ disabled, formData, onChange, schema }) => {
    const handleChange = (resource) => {
        if (resource) {
            onChange(`matrix-asset://${resource.source.id}/${resource.id}`);
        }
        else {
            onChange(undefined);
        }
    };
    return (react_1.default.createElement(resource_browser_1.ResourceBrowser, { modalTitle: "Insert resource", allowedTypes: schema.matrixAssetTypes, isDisabled: disabled, onChange: handleChange, value: (0, react_1.useMemo)(() => parseMatrixAssetUri(formData), [formData]) }));
};
exports.MatrixAssetWidget = MatrixAssetWidget;
